// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.93.0_@swc+core@1.7.1_@swc+helpers@0.5.5__/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.93.0_@swc+core@1.7.1_@swc+helpers@0.5.5__/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cj8e0F7M_2XxXFlbd5zL{margin-top:20px;padding:8px 0;border-bottom:1px solid var(--blue-grey-200)}.md_IU_XP4ZNIc6XyszlK{padding:8px 0}`, "",{"version":3,"sources":["webpack://./src/domains/SingleActivityView/SingleActivityViewDetails/SingleActivityViewDetails.module.scss"],"names":[],"mappings":"AAAA,sBACE,eAAA,CACA,aAAA,CACA,4CAAA,CAGF,sBACE,aAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"detailsContainer": `cj8e0F7M_2XxXFlbd5zL`,
	"paddingContainer": `md_IU_XP4ZNIc6XyszlK`
};
export default ___CSS_LOADER_EXPORT___;
